// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-selection__cancel, .product-selection__submit, .product-selection__error-label, .product-selection__info-label, .product-selection-counter__value, .product-selection-counter__label {
  font-family: "Jost", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.product-selection__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 33px;
}
@media screen and (min-width: 1025px) {
  .product-selection__container {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 60px;
  }
}
.product-selection__step-description {
  font-family: "Jost", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  background-color: #ffffff;
  padding: 32px 0;
  margin-bottom: 28px;
  z-index: 1;
}
@media screen and (min-width: 1025px) {
  .product-selection__step-description {
    text-align: start;
    position: sticky;
    top: 0;
    left: 0;
    margin-bottom: 20px;
  }
}
.product-selection__list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
@media screen and (min-width: 1025px) {
  .product-selection__list {
    width: auto;
  }
}
.product-selection__list--confirm .product-card__container {
  margin-right: auto;
  width: calc(100% - 79px);
}
@media screen and (min-width: 1025px) {
  .product-selection__list--confirm .product-card__container {
    width: 100%;
  }
}
.product-selection__actions {
  width: 100%;
  background-color: #f0f0f0;
  padding: 42px 32px;
  margin-top: 103px;
}
@media screen and (min-width: 1025px) {
  .product-selection__actions {
    position: sticky;
    top: 81px;
    right: 0;
    width: 724px;
    padding: 64px;
    margin-top: 24px;
  }
}
@media screen and (min-width: 1441px) {
  .product-selection__actions {
    margin-top: 0;
  }
}
.product-selection__counter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 32px;
  border-bottom: 1px solid #bdbdbd;
}
.product-selection-counter__value {
  font-weight: 700;
}
.product-selection__info-label {
  font-size: 16px;
  margin-top: 32px;
}
.product-selection__error-label {
  color: #ed4848;
  height: 24px;
  margin-top: 8px;
  transition: opacity 0.35s;
}
.product-selection__error-label.hidden {
  opacity: 0;
}
.product-selection__buttons {
  display: flex;
  flex-direction: column;
  margin-top: 32px;
}
.product-selection__cancel {
  margin-top: 32px;
}`, "",{"version":3,"sources":["webpack://./src/common.scss","webpack://./src/components/Return/Return.scss"],"names":[],"mappings":"AAqBA;EACE,+BApBe;EAqBf,eAAA;EACA,iBAAA;EACA,sBAAA;ACpBF;;ADqCA;EACE;IACE,uBAAA;EClCF;EDoCA;IACE,yBAAA;EClCF;AACF;AAXE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AAaJ;AAXI;EAPF;IAQI,mBAAA;IACA,8BAAA;IACA,eAAA;IACA,gBAAA;EAcJ;AACF;AAXE;EACE,+BDlBW;ECmBX,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDrBc;ECsBd,eAAA;EACA,mBAAA;EACA,UAAA;AAaJ;AAXI;EAdF;IAeI,iBAAA;IACA,gBAAA;IACA,MAAA;IACA,OAAA;IACA,mBAAA;EAcJ;AACF;AAXE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAaJ;AAXI;EAPF;IAQI,WAAA;EAcJ;AACF;AAXM;EACE,kBAAA;EACA,wBAAA;AAaR;AAXQ;EAJF;IAKI,WAAA;EAcR;AACF;AATE;EACE,WAAA;EACA,yBD3DS;EC4DT,kBAAA;EACA,iBAAA;AAWJ;AATI;EANF;IAOI,gBAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,aAAA;IACA,gBAAA;EAYJ;AACF;AAVI;EAfF;IAgBI,aAAA;EAaJ;AACF;AAVE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;AAYJ;AAJI;EAEE,gBAAA;AAKN;AADE;EAEE,eAAA;EACA,gBAAA;AAEJ;AACE;EAEE,cDpGU;ECqGV,YAAA;EACA,eAAA;EACA,yBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAIE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;AASE;EAEE,gBAAA;AARJ","sourcesContent":["// Fonts\n$font-primary: 'Jost', sans-serif;\n$font-secondary: 'Jost', sans-serif;\n\n// Colors\n$color-primary: #0f0f0f;\n$color-secondary: #ffffff;\n$light-gray: #f0f0f0;\n$gray: #bdbdbd;\n$medium-gray: #8c8c8c;\n$dark-gray: #545454;\n$color-alert: #ed4848;\n\n// Placeholders\n%body-s {\n  font-family: $font-secondary;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.04em;\n}\n\n%body-m {\n  font-family: $font-secondary;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n}\n\n%body-l {\n  font-family: $font-secondary;\n  font-size: 18px;\n  line-height: 26px;\n  letter-spacing: 0.01em;\n}\n\n// Animations\n$speed-smooth: 1s;\n$speed-slow: 0.65s;\n$speed-medium: 0.35s;\n$speed-fast: 0.25s;\n$speed-very-fast: 0.15s;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import \"../../common.scss\";\n\n.product-selection {\n  &__container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-top: 33px;\n\n    @media screen and (min-width: 1025px) {\n      flex-direction: row;\n      justify-content: space-between;\n      flex-wrap: wrap;\n      margin-top: 60px;\n    }\n  }\n\n  &__step-description {\n    font-family: $font-primary;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 17px;\n    letter-spacing: 1.1px;\n    text-transform: uppercase;\n    text-align: center;\n    width: 100%;\n    background-color: $color-secondary;\n    padding: 32px 0;\n    margin-bottom: 28px;\n    z-index: 1;\n\n    @media screen and (min-width: 1025px) {\n      text-align: start;\n      position: sticky;\n      top: 0;\n      left: 0;\n      margin-bottom: 20px;\n    }\n  }\n\n  &__list {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    @media screen and (min-width: 1025px) {\n      width: auto;\n    }\n\n    &--confirm {\n      .product-card__container {\n        margin-right: auto;\n        width: calc(100% - 79px);\n\n        @media screen and (min-width: 1025px) {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &__actions {\n    width: 100%;\n    background-color: $light-gray;\n    padding: 42px 32px;\n    margin-top: 103px;\n\n    @media screen and (min-width: 1025px) {\n      position: sticky;\n      top: 81px;\n      right: 0;\n      width: 724px;\n      padding: 64px;\n      margin-top: 24px;\n    }\n\n    @media screen and (min-width: 1441px) {\n      margin-top: 0;\n    }\n  }\n\n  &__counter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 32px;\n    border-bottom: 1px solid $gray;\n  }\n\n  &-counter {\n    &__label {\n      @extend %body-m;\n    }\n\n    &__value {\n      @extend %body-m;\n      font-weight: 700;\n    }\n  }\n\n  &__info-label {\n    @extend %body-m;\n    font-size: 16px;\n    margin-top: 32px;\n  }\n\n  &__error-label {\n    @extend %body-m;\n    color: $color-alert;\n    height: 24px;\n    margin-top: 8px;\n    transition: opacity $speed-medium;\n\n    &.hidden {\n      opacity: 0;\n    }\n  }\n\n  &__buttons {\n    display: flex;\n    flex-direction: column;\n    margin-top: 32px;\n  }\n\n  &__submit {\n    @extend %body-m;\n  }\n\n  &__cancel {\n    @extend %body-m;\n    margin-top: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
